// TODO dedup this across policy/agent
export const interventionSituationTypes = {
  WORD: 'WORD',
  PHRASE: 'PHRASE',
  END_OF_STORY: 'END_OF_STORY',
  WORD_PREP: 'WORD_PREP',
};

export const interventionTypes = {
  clap: 'clap',
  lipsync: 'lipsync',
  sayit: 'sayit',
  spellout: 'spellout',
  spelloutBefore: 'spelloutBefore',
  read: 'read',
  none: 'none',
  toofast: 'toofast',
  repeatsentence: 'repeatsentence',
  repeatsentenceErrorsEmphasized: 'repeatsentenceErrorsEmphasized',
  simpledefinition: 'simpledefinition',
  funfact: 'funfact',
  tense: 'tense',
  sight: 'sight',
  giveword: 'giveword',
  phonemeGiveWord: 'phonemeGiveWord',
  phonemeLipsync: 'phonemeLipsync',
  comprehension: 'comprehension',
  cognate: 'cognate',
  prediction: 'prediction',
  vocabularyWithPictures: 'vocabularyWithPictures',
  morpheme: 'morpheme',
  riddle: 'riddle',
  letterFlies: 'letterFlies',
  sayASound: 'sayASound',
  soundSeeker: 'soundSeeker',
  name1: 'name1',
  name2: 'name2',
  soundout1: 'soundout1',
  soundout2: 'soundout2',
  soundout3: 'soundout3',
  elkoninBox0: 'elkoninBox0',
  elkoninBox1: 'elkoninBox1',
  elkoninBox2: 'elkoninBox2',
  elkoninBox3: 'elkoninBox3',
  elkoninBox4: 'elkoninBox4',
  upAndDown1: 'upAndDown1',
  upAndDown2: 'upAndDown2',
  upAndDown3: 'upAndDown3',
  wordDisplay: 'wordDisplay',
  changeOnePart1: 'changeOnePart1',
  giveAndTake1: 'giveAndTake1',
  rhyming1: 'rhyming1',
  rhymingQuiz1: 'rhymingQuiz1',
  sayOneSound1: 'sayOneSound1',
  wordInvestigator1: 'wordInvestigator1',
  wordInvestigator2: 'wordInvestigator2',
  wordScramble1: 'wordScramble1',
};